// Spanish display names for the catalog's English labels.
//
// A translation table, kept apart from the language LOGIC in videoLanguage.js
// so copy changes are a content edit, not a code edit -- and so adding a
// third language is a new labels.<code>.js rather than a growing object.
//
// DISPLAY ONLY. The stored `category` and the section/playlist ids stay
// English because they are functional keys: section grouping matches them
// (taxonomy.js CATEGORY_SEED), and the orientation rules match
// "orientation"/"tanf orientation" to decide the 80% completion threshold,
// the rewind-only seek bar and the CRM orientation_complete write.
// Translating a stored value would silently drop a video out of its section
// and out of its participant's credit.
//
// Wording follows the curriculum sheet's own Spanish column, so the app and
// the curriculum doc agree. A label missing from here renders as-is.
const ES_LABELS = {
  // Categories (as stored on the video row)
  "Career Exploration": "Exploración de Carreras",
  "Essential Skills": "Habilidades Esenciales",
  "Financial Literacy": "Educación Financiera",
  "Healthy Lifestyle": "Estilo de Vida Saludable",
  "Health Literacy": "Educación para la Salud",
  "Job Applications and Interviewing": "Solicitudes y Entrevistas",
  "Job Training": "Capacitación Laboral",
  "Language Arts": "Lengua y Literatura",
  Math: "Matemáticas",
  Science: "Ciencias",
  "Social Studies": "Estudios Sociales",
  GED: "GED",
  Orientation: "Orientación",
  "TANF Orientation": "Orientación TANF",

  // Sections (taxonomy.js SECTIONS)
  "Career Pathways": "Rutas Profesionales",
  "Job Skills": "Habilidades Laborales",
  "Life Skills": "Habilidades para la Vida",
  "GED Prep": "Preparación GED",

  // Playlist titles (taxonomy.js CATEGORY_SEED)
  "Explore Careers": "Explorar Carreras",
  "Workplace Readiness": "Preparación para el Trabajo",
  "Health & the Body": "La Salud y el Cuerpo",
  "Reading & Language Arts": "Lectura y Lengua",
  "GED Core & Practice": "GED: Fundamentos y Práctica",
};

export default ES_LABELS;
